var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Breadcrumb',{attrs:{"breadcrumb":_vm.breadcrumb}}),_c('div',{staticClass:"wrap max-width"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.data ? _vm.data.title : ''))]),_c('div',{staticClass:"cont",domProps:{"innerHTML":_vm._s(_vm.data.cont)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }